import React from "react";
import { Card, Row, Col, Typography, Grid, Breadcrumb, theme } from "antd";
import {
  UserOutlined,
  QrcodeOutlined,
  ShopOutlined,
  ScheduleOutlined,
  MessageOutlined,
  NotificationOutlined,
  ArrowRightOutlined,
  CalendarOutlined,
  SettingOutlined,
  FireOutlined
} from "@ant-design/icons";
import { useAuth } from "../../context/AuthProvider";
import ForbiddenPage from "../Status/ForbiddenPage";
import { useNavigate } from "react-router-dom";



const { Title, Paragraph, Text } = Typography;


export default function AdminDashboard() {
  const screens = Grid.useBreakpoint();

  const isMobile = !screens.md;
  const navigate = useNavigate();
  const { user } = useAuth();
  const { token } = theme.useToken(); //  tokens de colores dinámicos

  if (user?.id !== 1) {
    return <ForbiddenPage />;
  }

  const actions = [
    { key: "qr", label: "Códigos QR", icon: <QrcodeOutlined />, path: "/admin/qr" },
    { key: "users", label: "Dinámicos", icon: <UserOutlined />, path: "/admin/users" },
    { key: "store", label: "Productos", icon: <ShopOutlined />, path: "/admin/store" },
    { key: "activities", label: "Actividades", icon: <ScheduleOutlined />, path: "/admin/activities" },
    { key: "feedback", label: "Comentarios", icon: <MessageOutlined />, path: "/admin/feedback" },
    { key: "notifications", label: "Notificaciones", icon: <NotificationOutlined />, path: "/admin/notifications" },
    { key: "events", label: "Eventos", icon: <CalendarOutlined />, path: "/admin/events" },
    { key: "bravos", label: "Bravos", icon: <FireOutlined />, path: "/admin/bravos" },
    { key: "menu", label: "Menú", icon: <SettingOutlined />, path: "/admin/menu" },
    { key: "kermes", label: "Kermés", icon: <ShopOutlined />, path: "/admin/kermes" },
  ];

  return (
    <div style={{
      padding: "clamp(16px, 4vw, 32px)",
      maxWidth: 1200,
      margin: "0 auto",
      backgroundColor: token.colorBgLayout,
      minHeight: '100vh'
    }}>
      <Breadcrumb
        style={{ marginBottom: 24 }}
        items={[
          { title: <span style={{ color: token.colorTextDescription }}>Inicio</span> },
          { title: "Panel de Administración" },
        ]}
      />

      <section style={{ marginBottom: 40 }}>
        <Title level={2} style={{ marginBottom: 8, color: token.colorText }}>
          Panel de Administración
        </Title>
        <Paragraph style={{ fontSize: 16, color: token.colorTextSecondary, maxWidth: 600 }}>
          Bienvenido. Gestiona los recursos del sistema de forma centralizada y eficiente.
        </Paragraph>
      </section>

      <Row gutter={[24, 24]}>
        {actions.map((action) => (
          <Col xs={24} sm={12} md={8} lg={6} key={action.key}>
            <Card
              hoverable
              onClick={() => navigate(action.path)}
              style={{
                height: '100%',
                borderRadius: token.borderRadiusLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                backgroundColor: token.colorBgContainer,
                transition: 'all 0.3s ease',
              }}
              styles={{
                body: {
                  padding: isMobile ? 16 : 24,
                  gap: 16,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center' // Asegura centrado total
                }
              }}
            >
              {/* CONTENEDOR DEL ICONO (Estilo exacto al de Comentarios) */}
              <div
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 24,
                  color: token.colorPrimary,
                  backgroundColor: '#fadb14', // Sin fondos oscuros extraños
                  flexShrink: 0, // Evita que el icono se reduzca en pantallas pequeñas
                }}
              >
                {action.icon}
              </div>

              <Title level={4} style={{ marginBottom: 8, color: token.colorText, textAlign: 'center' }}>
                {action.label}
              </Title>

              <div style={{ marginTop: 'auto' }}>
                <Text strong style={{ color: token.colorPrimary, fontSize: 14 }}>
                  Gestionar <ArrowRightOutlined style={{ fontSize: 12, marginLeft: 4 }} />
                </Text>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
